<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="grupos.content"
      class="elevation-1 mt-5"
      :loading="loading"
      :server-items-length="grupos.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhum grupo encontrado"
      loading-text="Carregando grupos..."
      :options="optionsList"
    >
      <template v-slot:item.ativo="{ item }">
        <px-ativo :ativo="item.ativo"/>
      </template>
      <template v-slot:item.options="{ item }">
        <px-cadastro-grupo @change="onUpdate" :grupo-edit="item">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </px-cadastro-grupo>
        <v-btn icon @click="onClickDelete(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import GrupoService from './grupo-service';
import CadastroGrupo from './CadastroGrupo.vue';

export default {
  props: {
    grupos: Object,
    loading: Boolean,
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Descrição',
          value: 'descricao',
        },
        {
          text: 'Ordenação',
          value: 'ordenacao',
        },
        {
          text: 'Departamento',
          value: 'departamento.descricao',
        },
        {
          text: 'Ativo',
          value: 'ativo',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  methods: {
    onUpdate() {
      this.$emit('update');
    },
    updateOptions(options) {
      this.$emit('change', options);
    },
    deleteItem(item) {
      GrupoService.remove(item.id)
        .then(() => {
          this.$toast('Grupo removido', { color: 'success' });
          this.onUpdate();
        });
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja deletar o grupo?',
        'Esta ação não poderá ser desfeita!',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.deleteItem(item);
        });
    },
    goToCompradores(item) {
      this.$router.push({
        name: 'main.entidades.compradores',
        params: {
          id: item.id,
        },
      });
    },
  },
  components: {
    pxCadastroGrupo: CadastroGrupo,
  },
};
</script>
